import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import generateId from 'helpers/id';

import Icon from './Icon';

IconButton.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  duotone: PropTypes.bool,
  solid: PropTypes.bool,
  light: PropTypes.bool,
  iconStyles: PropTypes.object,
  iconClassName: PropTypes.string,
  buttonStyles: PropTypes.object,
  buttonClassName: PropTypes.string,
  tooltip: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  label: PropTypes.string,
  layers: PropTypes.arrayOf(PropTypes.element),
  onClick: PropTypes.func,
};

function IconButton({
  name,
  type = 'button',
  disabled = false,
  duotone = false,
  solid = false,
  light = false,
  iconStyles = {},
  iconClassName = '',
  buttonStyles = {},
  buttonClassName = '',
  tooltip = null,
  tooltipPlacement,
  label = null,
  layers,
  onClick = () => undefined,
}) {
  const [tooltipId] = useState(generateId('icon-button-'));
  const button = (
    <button type={type} onClick={onClick} className={`${buttonClassName}`} style={buttonStyles} disabled={disabled}>
      <Icon
        name={name}
        duotone={duotone}
        solid={solid}
        light={light}
        iconStyles={iconStyles}
        iconClassName={iconClassName}
        label={label}
        layers={layers}
      />
    </button>
  );
  if (tooltip) {
    return (
      <OverlayTrigger placement={tooltipPlacement} overlay={<Tooltip id={tooltipId}>{tooltip}</Tooltip>}>
        {button}
      </OverlayTrigger>
    );
  }
  return button;
}

export default IconButton;
